import { render } from "./ProjectItemSlide.vue?vue&type=template&id=115c66cc&scoped=true"
import script from "./ProjectItemSlide.vue?vue&type=script&lang=js"
export * from "./ProjectItemSlide.vue?vue&type=script&lang=js"

import "./ProjectItemSlide.vue?vue&type=style&index=0&id=115c66cc&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115c66cc"]])

export default __exports__